var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.791 4.5H8.21a2.5 2.5 0 0 0-2.44 1.958l-.584 2.625C5.448 9.03 5.72 9 6 9h12c.28 0 .552.029.815.083l-.583-2.625a2.5 2.5 0 0 0-2.44-1.958Zm4.744 5.405-.839-3.773A4 4 0 0 0 15.791 3H8.21a4 4 0 0 0-3.905 3.132l-.838 3.773A3.992 3.992 0 0 0 2 13v7h1.5v-2.5h17V20H22v-7c0-1.247-.57-2.361-1.465-3.095ZM6 10.5h12a2.5 2.5 0 0 1 2.5 2.5v3h-17v-3A2.5 2.5 0 0 1 6 10.5ZM8 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })));
};
export default SvgCar;